import { ExternalLink } from "lucide-react";
import { C } from "../../theme/tokens";
import { REG_LINK, REG_LINK_RU, isRussianTimezone } from "../../data/referralLinks";

/* Primary referral button + a small fallback link to the other domain.
   Russian timezones get the RU mirror first (main domain is blocked there);
   everyone else gets the main link with the mirror as a fallback. */
export function RegLinkButton({ t, label }) {
  const isRu = isRussianTimezone();
  const primary = isRu ? REG_LINK_RU : REG_LINK;
  const alt = isRu ? REG_LINK : REG_LINK_RU;
  const altLabel = isRu ? t.reg_link_alt_main : t.reg_link_alt_ru;

  return (
    <>
      <a
        href={primary}
        target="_blank"
        rel="noreferrer"
        style={{
          marginTop: 18,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 8,
          textDecoration: "none",
          padding: "15px 18px",
          borderRadius: 14,
          background: `linear-gradient(120deg, ${C.greenBright} 0%, ${C.green} 100%)`,
          color: "#0b0d13",
          fontFamily: "'Space Grotesk', sans-serif",
          fontWeight: 700,
          fontSize: 15,
        }}
      >
        {label}
        <ExternalLink size={16} />
      </a>
      <a
        href={alt}
        target="_blank"
        rel="noreferrer"
        style={{
          display: "block",
          marginTop: 10,
          textAlign: "center",
          color: C.mutedB,
          fontSize: 12.5,
          textDecoration: "underline",
        }}
      >
        {altLabel}
      </a>
    </>
  );
}
